export default {
    SERVER_API_KEY: process.env.REACT_APP_API_KEY,
}